module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ./~/@storybook/theming/~/core-js/internals/path.js
// module id = 582
// module chunks = 168707334958949